import { useId, useState } from 'react';

export function CopyField({ label, value }: { label: string; value: string }) {
  const id = useId();
  const [state, setState] = useState<'idle' | 'copied' | 'manual'>('idle');

  async function copy() {
    try {
      await navigator.clipboard.writeText(value);
      setState('copied');
    } catch {
      // Clipboard blocked: select the text so it can be copied by hand.
      (document.getElementById(id) as HTMLInputElement | null)?.select();
      setState('manual');
    }
    window.setTimeout(() => setState('idle'), 2500);
  }

  return (
    <div className="copy-field">
      <label htmlFor={id}>{label}</label>
      <div className="copy-row">
        <input id={id} type="text" readOnly value={value} spellCheck={false} />
        <button type="button" onClick={() => void copy()}>
          {state === 'copied' ? 'Copied' : 'Copy'}
        </button>
      </div>
      {state === 'manual' && <p className="hint">Selected. Press and hold, then choose Copy.</p>}
    </div>
  );
}
